var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.5 18.8h-7.65V6.05A2.55 2.55 0 0 1 15.4 3.5h5.1v15.3m-9.35 0H3.5V3.5h5.1a2.55 2.55 0 0 1 2.55 2.55zm0 0h1.7v1.7h-1.7z"
  })));
};
export default SvgEducation;